import React, { Component } from "react";
import Card from "react-md/lib/Cards/Card";
import CardTitle from "react-md/lib/Cards/CardTitle";
import CardText from "react-md/lib/Cards/CardText";
import Media, { MediaOverlay } from "react-md/lib/Media";
import "./Preview.scss";

class Preview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      mobile: true
    };
    this.handleResize = this.handleResize.bind(this);
  }
  componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize() {
    if (window.innerWidth >= 640) {
      this.setState({ mobile: false });
    } else {
      this.setState({ mobile: true });
    }
  }
  render() {
    const { item } = this.props;
    const { mobile } = this.state;
    const coverHeight = mobile ? 200 : 300;
    return (
      <Card key={item.name} raise className="md-grid md-cell md-cell--12">
        <Media
          style={{
            backgroundImage: `url(${item.cover})`,
            height: `${coverHeight}px`
          }}
          className="preview-cover"
        >
          <MediaOverlay>
            <CardTitle title={item.name} />
          </MediaOverlay>
        </Media>
        <CardText>
          {item.description}
        </CardText>
      </Card>
    );
  }
}

export default Preview;



// WEBPACK FOOTER //
// ./src/components/Preview/Preview.jsx